import type { ChangeEvent } from 'react'

import { Line } from '@/components/elements/Line'
import { NewsTagButton } from '@/components/elements/News/NewsTagButton'
import { Select } from '@/components/elements/Select'
import { AccordionFilter } from '@/components/pages/News/AccordionFilter'
import { monthOptions } from '@/components/pages/News/dateOptions'
import { FilterField } from '@/components/pages/News/FilterField'

type Option = {
  value: string
  text: string
}

type Props = {
  yearOptions: readonly Option[]
  mediaTypeList: readonly string[]
  selectedTags: readonly string[]
  changeSelectedYear: (event: ChangeEvent<HTMLSelectElement>) => void
  changeSelectedMonth: (event: ChangeEvent<HTMLSelectElement>) => void
  changeSelectedTag: (text: string) => void
  handleAllTags: () => void
}

export const Filter = ({
  mediaTypeList,
  selectedTags,
  yearOptions,
  changeSelectedYear,
  changeSelectedMonth,
  changeSelectedTag,
  handleAllTags,
}: Props) => {
  return (
    <AccordionFilter>
      <FilterField title="公開日">
        <Select
          name="year"
          aria-label="公開年"
          defaultValue=""
          options={yearOptions}
          onChange={changeSelectedYear}
        />
        <Select
          name="month"
          aria-label="公開月"
          defaultValue=""
          options={monthOptions}
          onChange={changeSelectedMonth}
        />
      </FilterField>
      <Line color="grey" weight={1} direction="horizon" />
      <FilterField title="媒体">
        <NewsTagButton
          tag={{ name: 'すべて', code: 'all' }}
          isActive={selectedTags.length === 0}
          onClick={handleAllTags}
          disabled={selectedTags.length === 0}
        />
        {mediaTypeList.map((tag) => (
          <NewsTagButton
            tag={{ name: tag, code: tag }}
            key={tag}
            isActive={selectedTags?.includes(tag) ?? false}
            onClick={() => changeSelectedTag(tag)}
          />
        ))}
      </FilterField>
    </AccordionFilter>
  )
}
